// The image type used for every sheet in a "buy all / digital images only"
// order: the FIRST non-yearbook type in list order. (The Download/Digital name
// lookups and the types[0] fallback only come into play in the all-yearbook
// edge case, where the first find returns nothing — preserved as-is from the
// original inline logic; not a real priority ordering.) Returns undefined ONLY
// when imageTypes is empty (e.g. still loading) — callers must guard that before
// dereferencing, or the senior builder white-screens on `firstImageType.id`.
// Name access is nullish-safe so a type with a missing name can't throw either.
export function firstBuyAllImageType(imageTypes) {
  const types = imageTypes || [];

  return types.find((it) => it.name !== 'Yearbook Pose')
    || types.find((it) => (it.name || '').includes('Download'))
    || types.find((it) => (it.name || '').includes('Digital'))
    || types[0];
}

export function stripImageTypeName(imageType) {
  if (!imageType) return '';

  const numberInNameArr = imageType.name.match(/\(\d*\)/);

  if (!numberInNameArr) return imageType.name.toLowerCase();

  const numberInName = numberInNameArr[0];

  return imageType
    .name
    .toLowerCase()
    .replace(numberInName, '')
    .trim();
}

export function getNumImgsPerSheetByName(imageTypeNameWithoutNum, inPreview = false) {
  if (imageTypeNameWithoutNum.includes('ornament') && !inPreview) {
    return 1;
  }
  if (imageTypeNameWithoutNum.includes('ornament') && inPreview) {
    return 1;
  }
  if (imageTypeNameWithoutNum.includes('magnet') && !imageTypeNameWithoutNum.includes('calendar')) {
    return 2;
  }

  if (imageTypeNameWithoutNum.includes('card')) {
    return 2;
  }

  const regexMatch = imageTypeNameWithoutNum.match(/\dx\d*/gm);

  let str = imageTypeNameWithoutNum;
  if (regexMatch && regexMatch.length > 0) {
    str = regexMatch[0];
  }

  if (str === '8x10') return 1;
  if (str === '5x7') return 2;
  if (str === '3x5') return 4;
  if (str === 'wallets') return 8;

  return 1;
}

export function calculateAdditionalPoses(sheets, option) {
  const numPoses = option.digitalImagesOnly ? Number.POSITIVE_INFINITY : option.poses;

  const poses = sheets
    .filter((sheet) => sheet.imageType.name !== 'Yearbook Pose')
    .map((sheet) => sheet.poseId);
  const uniquePoses = [...new Set(poses)].length;

  return Math.max(uniquePoses - numPoses, 0);
}

export function addonSheetToSheet(addonSheet) {
  return ({
    ...addonSheet,
    imageTypeId: addonSheet.addonId,
    imageType: { ...addonSheet.addon, addon: addonSheet.addon, classname: addonSheet.addon.cssName, component: addonSheet.addon.component },
  });
}

const imageTypeWeights = {
  '8x10': 0,
  '8x10 enlargements': 0,
  'mounted portrait': 100,
  '5x7': 200,
  '3x5': 300,
  wallets: 400,
  'digital files': 500,
  'digital file': 500,
  'high-res digital download': 500,
  'yearbook pose': 600,
};

export function imageTypeSorter(imageType1, imageType2) {
  const weight1 = imageTypeWeights[stripImageTypeName(imageType1)];
  const weight2 = imageTypeWeights[stripImageTypeName(imageType2)];

  if (weight1 < weight2) return -1;

  return 1;
}
